// import "./BarcodeLabel.scss";
import Barcode from "react-barcode";
import IntoBarcodeLable from "./IntoBarcodeLable";

export default function BarcodeLabel({
                                       barcodeCount,
                                       barcodeCountUserInput,
                                       barcodeLength,
                                       barcodeWidth,
                                       paperWidth,
                                       productCode,
                                       productColor,
                                       productName,
                                       productPrice,
                                       productSize,
                                       productFont,
                                       priceFont,
                                       displayProductCodeValue
                                     }) {
  const cssJustInThisPage = `
      
      .paperWidthToUse{
        display: flex;
        flex-wrap: wrap;
        justify-content:space-between;
        width: ${barcodeWidth}mm;
        max-height:${barcodeLength}mm;
      }
    .singleBarcodeWidthAndHeight{
        width: ${barcodeWidth}mm !important;
        height: ${barcodeLength - 0.2}mm !important;
        padding:0;
        margin:0;
        overflow: hidden;
        direction:ltr;
        display: flex; 
        justify-content: space-around;
        flex-direction: row-reverse;
        flex-wrap: nowrap;
        /*background:#bcbcbc;*/
        /*border-right:1px solid;*/
    }
    .barcode-spec{
    width:100%;
    width: ${barcodeWidth * 0.8}mm;
    text-align: center; 
    
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}
        .product-name {
            line-height:11px;
            font-size: ${productFont}px;
            width: ${barcodeWidth * 0.8}mm;
            height: 30%;
            overflow:hidden;
            display: flex;
            text-align: center;
            align-items: center;
            justify-content: center;
              
        }
        .product-price {
              font-size:${priceFont!==undefined ? priceFont+'px' :'4mm'};
              font-weight:700;
        }
    .barcode-opt{
      display: flex;
      writing-mode: vertical-rl;
      font-size: 10px !important;
      justify-content: space-around;
      width:20%;
      align-items: center;
      font-weight: 700;
    }
    
    @media print{
        @page {
            size: ${paperWidth}mm ${barcodeLength}mm !important;
        }
        .paperWidthToUse{
         width: ${paperWidth}mm;
         height:auto;
        }
    }
    div.page
      {
        page-break-after: always !important;
        page-break-inside: avoid !important;
      }
    `;


  return (<>
    <style>{cssJustInThisPage}</style>
    <div className={"paperWidthToUse__Out"}>
      {[...Array(Math.ceil(barcodeCountUserInput / barcodeCount))].map((e, index1) =>
        <>
          <div className={"paperWidthToUse"} style={{}}>
            {[...Array(barcodeCount)].map((e, index2) =>
              <>
                <IntoBarcodeLable
                  productName={productName}
                  productPrice={productPrice}
                  productCode={productCode}
                  barcodeLength={barcodeLength}
                  barcodeWidth={barcodeWidth}
                  displayProductCodeValue={displayProductCodeValue}
                  productColor={productColor}
                  productSize={productSize}
                />
                {/*<div className={"page"}></div>*/}
              </>
            )}
          </div>
          {(index1 + 1) % barcodeCount === 0 && <div className={"page"}></div>}
        </>
      )}
    </div>
  </>);
}
